<template>
  <div>
    <transition name="vue-table-loader">
      <div class="vue-details-loader alt" v-if="loading">
        <span class="fa fa-cog fa-spin fa-1x"></span>
      </div>
    </transition>
    <div>
      <div class="row mt-2 d-flex align-items-center">
        <div class="col-md-6 d-flex flex-column">
          <h4 class="mb-0">Folders</h4>
        </div>
        <div class="col-md-6 d-flex align-items-center justify-content-end">
          <button data-id="create-folder-button" class="btn ml-2 btn-outline-primary" @click="uiStates.createFolderModal = true">
              Create Folder
          </button>
        </div>
      </div>
      <transition name="fade">
        <div v-if="uiStates.createFolderModal" class="modal-wrapper">
          <div class="modal-bg" @click="uiStates.createFolderModal = false"></div>
          <div class="d-flex flex-column modal-inner p-4">
            <label>
              Folder Name
            </label>
            <input data-id="create-folder-input" type="text" name="createFolder" class="form-control" style="min-width: 18rem;" v-model="createFolderModal.folderName">
            <button data-id="create-folder-submit" class="btn my-2 btn-primary" :disabled="loading" @click="handleCreateFolder()">Submit</button>
          </div>
        </div>
      </transition>
      <div class="dataTables_wrapper container-fluid dt-bootstrap4" data-id="folder-list-table">
        <vuetable
          ref="vuetable"
          :fields="fields"
          :api-url="apiURL"
          :data-path="'payload'"
          :css="css.table"
          :per-page="perPage"
          :append-params="moreParams"
          noDataTemplate="No Folders Found"
          pagination-path=""
          @vuetable:loaded="onLoaded"
        >
          <template slot="name-slot" slot-scope="props">
            <a :href="'/assets/folder/' + props.rowData.id" class="folder-link">
              <i class="fa fa-folder mr-2" aria-hidden="true"></i>
              <span>
                {{ props.rowData.name }}
              </span>
            </a>
          </template>
          <template slot="actions-slot" slot-scope="props">
            <div class="d-flex align-items-center justify-content-end">
              <a :href="'/assets/folder/' + props.rowData.id" class="btn btn-sm btn-primary">View</a>
              <button v-if="permissions.length && permissions.includes('delete_dam')" @click="handleDeleteFolder(props.rowData.id)" class="btn btn-sm btn-danger ml-1">Delete</button>
            </div>
          </template>
        </vuetable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const base_url = window.location.protocol + "//" + window.location.host;

export default {
  name: "dam-folder-list",
  props: {
    currentFolder: {
      required: false,
      type: [Object, String]
    },
    root: {
      required: false,
      type: Boolean
    },
    permissions: {
      required: false,
      type: [Object, Array]
    }
  },
  data() {
    return {
      perPage: 10,
      loading: true,
      uiStates: {
        errorMessage: null,
        showLoading: true,
        createFolderModal: false
      },
      createFolderModal: {
        folderName: ''
      },
      moreParams: {},
      fields: [
        {
          name: "__slot:name-slot",
          title: "Name",
        },
        {
          name: "size_readable",
          title: "Size",
        },
        {
          name: "created_at",
          title: "Created",
        },
        {
          name: "updated_at",
          title: "Updated",
        },
        {
          name: "__slot:actions-slot",
          title: "",
        },
      ],
      css: {
        table: {
          tableClass: "table table-middle table-minimal",
          ascendingIcon: "sort-icon-asc",
          descendingIcon: "sort-icon-desc",
          infoClass: "",
        },
      },
    };
  },
  computed: {
    apiURL() {
      return this.root ? 
        `${base_url}/pimapi/assets/folder/0/folders` : 
        `${base_url}/pimapi/assets/folder/${this.currentFolder.id}/folders`;
    }
  },
  methods: {
    handleCreateFolder() {
      let payload = {};

      if (!this.root) {
        payload.parentId = this.currentFolder.id;
      }

      payload.name = this.createFolderModal.folderName;

      this.loading = true;

      axios.post('/pimapi/assets/folder', payload)
        .then(function (response) {
          this.loading = false;
          this.uiStates.createFolderModal = false;
          this.createFolderModal.folderName = '';
          this.$refs.vuetable.refresh();
          this.$emit('alert', {
              message: 'Success, folder created',
              status: "alert-success"
          });
        }.bind(this))
        .catch(function (error) {
          console.log(error);
          this.loading = false;
          this.$emit('alert', {
              message: error.response.data.message,
              status: "alert-danger"
          });

          this.uiStates.createFolderModal = '';
          this.createFolderModal.folderName = '';
        }.bind(this));
    },
    handleDeleteFolder(id) {
      this.loading = true;

      axios.delete(`/pimapi/assets/folder/${id}`)
        .then(function (response) {
          this.loading = false;
          this.$refs.vuetable.refresh();
          this.$emit('alert', {
              message: 'Success, folder deleted',
              status: "alert-success"
          });
        }.bind(this))
        .catch(function (error) {
          console.log(error);
          this.loading = false;
          this.$emit('alert', {
              message: error.response.data.message,
              status: "alert-danger"
          });
        }.bind(this));
    },
    onLoaded: function () {
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.folder-link {
  color: #333;
}
</style>
